export default __webpack_public_path__ + "static/202-257429cfb39588b911be5d106a6caead.jpg";